const styles = theme => ({
  cardSettingsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '24px',
    alignSelf: 'stretch',
    padding: '16px 0',
  },

  // Section styling
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '12px',
    alignSelf: 'stretch',
  },

  sectionTitle: {
    color: 'var(--mcg-darkgray, #282F35)',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%', // 24px
  },
  checkIcon: {
    fontSize: '20px',
    color: '#015ffb',
  },
  featureIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  featureIconButton: {
    padding: '6px',
    minWidth: 'unset',
    border: '1px solid var(--Gray-Lighter, #E5E7EB)',
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: 'rgba(1, 95, 251, 0.1)',
      borderColor: 'var(--mcg-blue, #015FFB)',
    },
  },
  sectionDescription: {
    color: 'var(--mcg-gray, #919EAB)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '18px', // 163.636%
  },

  // Image upload styling
  imageUploadContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '12px',
    alignSelf: 'stretch',
  },

  imagePreview: {
    position: 'relative',
    width: '100%',
    maxWidth: '360px',
    height: '200px',
    borderRadius: '8px',
    overflow: 'hidden',
    backgroundColor: '#F4F6F8',
    border: '1px solid var(--Gray-Lighter, #E5E7EB)',
  },

  previewImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },

  deleteButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
  },

  fileInput: {
    display: 'none',
  },

  uploadButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 16px',
    backgroundColor: 'var(--mcg-blue, #015FFB)',
    color: 'white',
    borderRadius: '6px',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    border: 'none',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: 'var(--mcg-blue-dark, #0047CC)',
    },
  },

  uploadInfo: {
    color: 'var(--mcg-gray, #919EAB)',
    fontFamily: 'Inter',
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '16px',
  },

  // Features styling
  featuresContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '12px',
    alignSelf: 'stretch',
  },

  featureItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
  },

  featureCheckIcon: {
    padding: '4px',
    width: '24px',
    height: '24px',
    '&:hover': {
      backgroundColor: 'rgba(1, 95, 251, 0.1)',
    },
  },

  checkedIcon: {
    color: 'var(--mcg-blue, #015FFB)',
  },

  uncheckedIcon: {
    color: 'var(--mcg-gray, #919EAB)',
  },

  featureInput: {
    flex: 1,
    '& .MuiOutlinedInput-root': {
      height: '45px',
      fontSize: '14px',
      fontFamily: 'Inter',
      '& fieldset': {
        borderColor: 'var(--Gray-Lighter, #E5E7EB)',
        borderRadius: '6px',
      },
      '&:hover fieldset': {
        borderColor: 'var(--mcg-blue, #015FFB)',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'var(--mcg-blue, #015FFB)',
        borderWidth: '1px',
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '12px 12px',
      fontSize: '14px',
      fontFamily: 'Inter',
    },
  },

  closeButton: {
    padding: '4px',
    color: 'var(--mcg-gray, #919EAB)',
    '&:hover': {
      backgroundColor: 'rgba(145, 158, 171, 0.1)',
      color: 'var(--mcg-red, #FF4757)',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
    },
  },
})

export default styles
